import React from "react";
import { PageLayout, BlogPostNavigation } from "@bluefin/components";
import { Embed, Grid } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class CateringDiaryAndBlogPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { allFishermanBusinessBlogPost } = data;

    return (
      <WebsiteLayout>
        <PageLayout
          hero={null}
          subfooter={false}
          className={"vlog-catering-diary-page"}
        >
          <div className={"home-page"}>
            <div className={"home-hero-video-container"}>
              <div className={"hero-overlay"} />
              <Embed
                url={"https://player.vimeo.com/video/1147681801?background=1"}
                autoplay={true}
                className={"home-hero-video"}
                active={true}
                defaultActive={true}
              />
              <div className={"hero-content"} />
            </div>
          </div>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={14} textAlign={"center"}>
              <Grid
                stackable={true}
                className={"component-section-container custom-banner"}
                verticalAlign={"top"}
                textAlign={"center"}
                columns={"3"}
              >
                <Grid.Row streched={true}>
                  <Grid.Column>
                    <Embed
                      url={
                        "https://player.vimeo.com/video/1147682441?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      }
                      autoplay={true}
                      className={""}
                      active={true}
                      defaultActive={true}
                    />
                    <div>
                      HoneyDip Fingerz went above & beyond for a client and
                      delivered a native dish at a wedding. #HoneyDipFingerz
                      #NigerianFood #NigerianPartyCateringInDallas
                      #WeddingBuffetService #Banga&Starch
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <Embed
                      url={
                        "https://player.vimeo.com/video/1147682312?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      }
                      autoplay={true}
                      className={""}
                      active={true}
                      defaultActive={true}
                    />
                    <div>
                      Onsite at a Client's birthday party we prepared and served
                      delicious dishes from appetizers to entrees.
                      #HoneyDipFingerz #Ayamase #NigerianCateringInDallas
                      #NigerianTradWeddinginDallas
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <Embed
                      url={
                        "https://player.vimeo.com/video/1147681714?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      }
                      autoplay={true}
                      className={""}
                      active={true}
                      defaultActive={true}
                    />
                    <div>
                      Step into our full catering display of appetizers &
                      bespoke dishes including our popular Abula-On-The-Spot.
                      #HoneyDipFingerz #NigerianFood
                      #NigerianPartyCateringInDallas #AbulaOnSpot
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <Embed
                      url={
                        "https://player.vimeo.com/video/1147681979?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      }
                      autoplay={true}
                      className={""}
                      active={true}
                      defaultActive={true}
                    />
                    <div>
                      Come behind the scenes with us at a Traditional Wedding,
                      for a special meal highlight on Ayamase. #HoneyDipFingerz
                      #Ayamase #NigerianCateringInDallas
                      #NigerianTradWeddinginDallas.
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <Embed
                      url={
                        "https://player.vimeo.com/video/1147681877?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      }
                      autoplay={true}
                      className={""}
                      active={true}
                      defaultActive={true}
                    />
                    <div>
                      Join us behind the scenes for a sneak peek into how our
                      yummy puff puffs are made to order. #HoneyDipFingerz
                      #NigerianAppetizers #NigerianSnacksInDallas
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <Embed
                      url={
                        "https://player.vimeo.com/video/1147682170?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      }
                      autoplay={true}
                      className={""}
                      active={true}
                      defaultActive={true}
                    />
                    <div>
                      See how we brought the client's small bites menu ideas to
                      life at a Women's Conference in Farmer's Branch.
                      #HoneyDipFingerz #NigerianSmallBites
                      #NigerianCateringInDallas
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid>
          <Grid stackable={true} className={"blog-page-container"}>
            <Grid.Column width={14}>
              <BlogPostNavigation
                title={""}
                blogRootSlug={"/catering-diary-and-blog/"}
                description={""}
                featuredPostId={null}
                alwaysShowSearch={true}
                columns={3}
                posts={allFishermanBusinessBlogPost.nodes}
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    allFishermanBusinessBlogPost {
      nodes {
        _id
        title
        slug
        author {
          firstName
          lastName
          avatar
          email
        }
        summary
        content
        heroImage
        gatsbyHeroImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        publishedAt
      }
    }
  }
`;
